var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronDownLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.637,
    height: 8.432,
    viewBox: "0 0 13.637 8.432",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".chevron_down_a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "chevron_down_a",
    d: "M7.6,8.58,12.818,13.8,18.034,8.58l1.6,1.614-6.818,6.818L6,10.194Z",
    transform: "translate(-6 -8.58)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronDownLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_chevron_down_light.f759d0ac9bd794a9e6e735c8a59c545d.svg";